import { useMutation } from "react-query";
import { employeesApi } from "frontend/src/api/employees";
import { queryClient } from "frontend/src/domain/query-client";
import { notify } from "frontend/src/features/notifications";
import { cacheKey } from "./shared";
export var useCreateClientEmployee = function () {
    return useMutation(employeesApi.create, {
        onSuccess: function () {
            notify({ variant: "success", message: "Сотрудник создан." });
        },
        onSettled: function () { return queryClient.invalidateQueries(cacheKey); },
    });
};
